import { render, staticRenderFns } from "./Foda.vue?vue&type=template&id=a9286a60&"
import script from "./Foda.vue?vue&type=script&lang=js&"
export * from "./Foda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports